import { withAuthRetry } from '../utils/authRetry';
import { getServiceBaseUrl } from '../utils/api';

// Simple interface for ProviderCase until proto is generated
export interface ProviderCase {
    id: string;
    cancerType: number;
    submitTime?: Date;
    status: number;
    aiJobStartTime?: Date;
    aiJobEndTime?: Date;
    verbosity?: number;
    reasoning?: number;
    finalModel?: string;
}

export interface GetProviderCasesRequest {
    offset: number;
    pageSize: number;
}

export interface GetProviderCasesResponse {
    cases: ProviderCase[];
    totalCount: number;
}

// Manual decoder for GetProviderCasesResponse until proto is auto-generated
function decodeGetProviderCasesResponse(bytes: Uint8Array): GetProviderCasesResponse {
    // Import the generated decoder when available
    // For now, implement a simple protobuf decoder
    const { BinaryReader } = require("@bufbuild/protobuf/wire");
    const reader = new BinaryReader(bytes);

    const response: GetProviderCasesResponse = { cases: [], totalCount: 0 };

    while (reader.pos < reader.len) {
        const tag = reader.uint32();
        const fieldNum = tag >>> 3;

        switch (fieldNum) {
            case 1: { // cases (repeated ProviderCase)
                const caseBytes = reader.bytes();
                const caseReader = new BinaryReader(caseBytes);
                const providerCase: ProviderCase = {
                    id: '',
                    cancerType: 0,
                    status: 0,
                };

                while (caseReader.pos < caseReader.len) {
                    const caseTag = caseReader.uint32();
                    const caseFieldNum = caseTag >>> 3;

                    switch (caseFieldNum) {
                        case 1: providerCase.id = caseReader.string(); break;
                        case 2: providerCase.cancerType = caseReader.int32(); break;
                        case 3: {
                            // Timestamp - need to read as submessage
                            const tsBytes = caseReader.bytes();
                            const tsReader = new BinaryReader(tsBytes);
                            let seconds = 0;
                            let nanos = 0;
                            while (tsReader.pos < tsReader.len) {
                                const tsTag = tsReader.uint32();
                                const tsField = tsTag >>> 3;
                                if (tsField === 1) seconds = Number(tsReader.int64());
                                else if (tsField === 2) nanos = tsReader.int32();
                                else tsReader.skip(tsTag & 7);
                            }
                            providerCase.submitTime = new Date(seconds * 1000 + nanos / 1000000);
                            break;
                        }
                        case 4: providerCase.status = caseReader.int32(); break;
                        case 5: {
                            const tsBytes = caseReader.bytes();
                            const tsReader = new BinaryReader(tsBytes);
                            let seconds = 0;
                            let nanos = 0;
                            while (tsReader.pos < tsReader.len) {
                                const tsTag = tsReader.uint32();
                                const tsField = tsTag >>> 3;
                                if (tsField === 1) seconds = Number(tsReader.int64());
                                else if (tsField === 2) nanos = tsReader.int32();
                                else tsReader.skip(tsTag & 7);
                            }
                            providerCase.aiJobStartTime = new Date(seconds * 1000 + nanos / 1000000);
                            break;
                        }
                        case 6: {
                            const tsBytes = caseReader.bytes();
                            const tsReader = new BinaryReader(tsBytes);
                            let seconds = 0;
                            let nanos = 0;
                            while (tsReader.pos < tsReader.len) {
                                const tsTag = tsReader.uint32();
                                const tsField = tsTag >>> 3;
                                if (tsField === 1) seconds = Number(tsReader.int64());
                                else if (tsField === 2) nanos = tsReader.int32();
                                else tsReader.skip(tsTag & 7);
                            }
                            providerCase.aiJobEndTime = new Date(seconds * 1000 + nanos / 1000000);
                            break;
                        }
                        case 7: providerCase.verbosity = caseReader.int32(); break;
                        case 8: providerCase.reasoning = caseReader.int32(); break;
                        case 9: providerCase.finalModel = caseReader.string(); break;
                        default: caseReader.skip(caseTag & 7);
                    }
                }
                response.cases.push(providerCase);
                break;
            }
            case 2: { // total_count
                response.totalCount = Number(reader.int64());
                break;
            }
            default:
                reader.skip(tag & 7);
        }
    }

    return response;
}

export async function getProviderCases(
    request: GetProviderCasesRequest,
    accessToken: string,
    setAccessToken: (token: string | null) => void,
    logout: () => void
): Promise<GetProviderCasesResponse> {
    const originalApiCall = async (token: string): Promise<Response> => {
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        };

        const { baseUrl, stagingSuffix } = getServiceBaseUrl('intakeservice');
        const url = `${baseUrl}/getprovidercases${stagingSuffix}?offset=${request.offset}&page_size=${request.pageSize}`;

        const response = await fetch(url, {
            method: 'GET',
            headers,
        });
        return response;
    };

    return withAuthRetry(originalApiCall, accessToken, decodeGetProviderCasesResponse, setAccessToken, logout);
}
